import simple5phase from './models/simple5phase.js';
import floatingPoint1 from './models/floatingpoint1.js';
import floatingPoint2 from './models/floatingpoint2.js';
import ppl486 from './models/ppl486.js';
import arm926ejs from './models/arm926ej-s.js';
import raspberry1 from './models/raspberry1.js';

const pipelineModels = {
    [simple5phase.name]: simple5phase,
    [floatingPoint1.name]: floatingPoint1,
    [floatingPoint2.name]: floatingPoint2,
    [ppl486.name]: ppl486,
    [arm926ejs.name]: arm926ejs,
    [raspberry1.name]: raspberry1,
};

export default pipelineModels;